"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const useQCurrency_1 = __importDefault(require("components/QCurrency/useQCurrency"));
const PlayArrowRounded_1 = __importDefault(require("@mui/icons-material/PlayArrowRounded"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const ValueText = styled_components_1.default.span `text-align: right;`;
const ValueFieldWrapper = styled_components_1.default.div `position: relative; display: inline-block; white-space: nowrap;`;
const ValueField = (props) => {
    const { formatAmount } = (0, useQCurrency_1.default)();
    const { palette } = (0, styles_1.useTheme)();
    const { inputValue, color, type, valueChange, useParentheses, useTwoLines, fontSize = 12, style = {} } = props;
    const value = (inputValue === undefined || inputValue === null) ? 'N/A' : inputValue;
    const percent = (type === 'percentage') ? '%' : '';
    const marginRight = percent ? '-4px' : '0';
    const valueChangeFormatted = valueChange ? formatAmount(valueChange, 'USD') : '';
    const valueFormatted = ((type === 'percentage') ? (`${formatAmount(value, '')}${percent}`) : (`${formatAmount(value, 'USD')}${percent}`));
    const variant = color === 'sign' ? 'body1' : 'body2';
    const valueFormattedParenthesized = (`(${formatAmount(value, '')}%)`);
    if (value === 'N/A') {
        return (type === 'percentage'
            ? (<div />)
            : (<ValueText>{value}{percent}</ValueText>));
    }
    let theColor = palette.text.primary;
    if (color === 'sign') {
        if (value === 0) {
            theColor = palette.text.primary;
        }
        else if (value < 0) {
            theColor = palette.amount.negative;
        }
        else {
            theColor = palette.amount.positive;
        }
    }
    const arrowSx = { transform: 'rotate(270deg)', height: 20, width: 20 };
    return (<ValueFieldWrapper style={(Object.assign(Object.assign({}, style), { marginRight }))}>
      <Typography_1.default variant={variant} style={{ color: theColor, display: 'inline-block', fontWeight: 500, fontSize: `${fontSize}px` }}>
        {valueChangeFormatted}{(useTwoLines ? <br /> : ' ')}{(useParentheses ? valueFormattedParenthesized : valueFormatted)}
      </Typography_1.default>
      {type === 'percentage' && value < 0 &&
            <PlayArrowRounded_1.default sx={Object.assign(Object.assign({}, arrowSx), { transform: 'rotate(90deg)', color: palette.amount.negative })}/>}
      {type === 'percentage' && value > 0 &&
            <PlayArrowRounded_1.default sx={Object.assign(Object.assign({}, arrowSx), { color: palette.amount.positive })}/>}
    </ValueFieldWrapper>);
};
exports.default = ValueField;
